import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment-timezone';
import { getClientWorkers } from '../../../../reducers/clients';
import { RoleDefinitions } from '../../../../utilities/roles';
import { FormattedMessage } from 'react-intl';
import { getGreeting } from '../../../../utilities/string';
import messages from '../../../../text/messages';
import Card from '../../../../components/card';
import { getTimesheetSummary } from '../../../../reducers/timekeeping';
import { history } from '../../../../configuration/store';
import DashboardAlerts from './../../components/alerts';
import OnboardingList from './../../components/workers/onboarding';
import ExpirationsList from './../../components/workers/expirations';
import { expiringFilter, onboardingFilter, hideFilter } from '../../../../utilities/filterJobExt';
import { getUsers } from '../../../../reducers/users';
import { getClientsProjects } from '../../../../reducers/projects';
import { sendInvite } from '../../../../reducers/invites';

class ClientDashboard extends React.Component {
    constructor(props) {
        super(props);

        this.renderTimesheetsCard = this.renderTimesheetsCard.bind(this);
        this.inviteUser = this.inviteUser.bind(this);
    }

    inviteUser(values, onFinish) {
        const { role, sendInvite, getUsers } = this.props;

        sendInvite({ ...values, clientId: role.id, ref_id: role.id, ref_type: 'client' }, role, () =>
            getUsers(role, result => onFinish(result.find(u => u.email === values.email)))
        );
    }

    componentDidMount() {
        const { profile, role, getClientWorkers, getUsers, getTimesheetSummary, getClientsProjects } = this.props;
        const hmFilter = worker => (role.role === RoleDefinitions.ClientHiringManager.type ? worker.hm_id === profile.id : true);

        getUsers(role);
        getClientWorkers(role.id, hmFilter);
        getClientsProjects(role.id);
        getTimesheetSummary(role.id, role.role === RoleDefinitions.ClientHiringManager.type ? profile.id : undefined);
    }

    renderTimesheetsCard() {
        const { summary } = this.props;
        const {
            submitted,
            pending: { confirmed, notConfirmed }
        } = summary || { submitted: 0, pending: { confirmed: 0, notConfirmed: 0 } };

        const buttonAction = submitted ? { onClick: () => history.push('/time') } : {};
        const pendingAction = submitted ? { onClick: () => history.push('/time'), style: { cursor: 'pointer' } } : {};
        const openAction = confirmed || notConfirmed ? { onClick: () => history.push('/time', { defaultTab: 2 }), style: { cursor: 'pointer' } } : {};

        const content = (
            <div className="row">
                <div className="col-xs-4" {...pendingAction}>
                    <div className="timesheets-card-number">{submitted}</div>
                    <div className="timesheets-card-label">
                        <FormattedMessage {...messages.toApprove} />
                    </div>
                </div>
                <div className="col-xs-4" {...openAction}>
                    <div className="timesheets-card-number">{confirmed}</div>
                    <div className="timesheets-card-label">
                        <FormattedMessage {...messages.submitted} />
                    </div>
                </div>
                <div className="col-xs-4" {...openAction}>
                    <div className="timesheets-card-number">{notConfirmed}</div>
                    <div className="timesheets-card-label">
                        <FormattedMessage {...messages.open} />
                    </div>
                </div>
                <div className="col-xs-12">
                    {submitted > 0 && (
                        <span className="approve-all-button" {...buttonAction}>
                            <FormattedMessage {...messages.reviewApprove} />
                        </span>
                    )}
                </div>
            </div>
        );

        const allSetContent = (
            <div className="row">
                <div className="col-xs-12">
                    <span>
                        <FormattedMessage
                            id={'timesheetSummary.allSet'}
                            defaultMessage={'Week of {start} - {end} is all set.'}
                            values={{
                                start: moment()
                                    .add(-7, 'days')
                                    .startOf('isoWeek')
                                    .format('MMMM DD'),
                                end: moment()
                                    .add(-7, 'days')
                                    .endOf('isoWeek')
                                    .format('MMMM DD')
                            }}
                        />
                    </span>
                </div>
            </div>
        );

        return <Card title={<FormattedMessage {...messages.timesheets} />} content={submitted + confirmed + notConfirmed > 0 ? content : allSetContent} />;
    }

    render() {
        const { employments } = this.props;
        if (!employments) return null;
        const { user } = this.props;

        const expWorkers = employments.filter(expiringFilter);
        const onboarding = employments
            .filter(onboardingFilter)
            .filter(hideFilter('onboarding'))
            .filter(hideFilter('onboarding_client'));

        return (
            <React.Fragment>
                <div className="row greeting">
                    <div className="col-xs-12 col-sm-8">
                        <span className="greeting-message">
                            {getGreeting()} {user.first_name}
                        </span>
                    </div>
                    <div className="col-xs-12 col-sm-4">
                        <span className="invite-worker-button hidden-xs" onClick={() => history.push('/position/new')}>
                            <FormattedMessage {...messages.inviteWorker} />
                        </span>
                    </div>
                </div>
                <div className="row section">
                    <div className="col-md-8 col-xs-12">
                        {/* <HighPriorityAlerts /> */}
                        <OnboardingList {...this.props} workers={onboarding} />
                        <ExpirationsList {...this.props} workers={expWorkers} inviteUser={this.inviteUser} />
                    </div>
                    <div className="col-xs-12 col-sm-4">
                        {this.renderTimesheetsCard()}
                        <DashboardAlerts />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    const role = state.identity.role;
    const employments = state.clients.workers || [];
    const projects = state.projects.list;

    const projectsOptions = (projects || []).map(p => ({ value: p.id, label: p.name }));

    return {
        role,
        adminId: state.identity.details.admin_id,
        profile: state.identity.profile,
        users: state.users.list,
        projects,
        projectsOptions,
        employments,
        summary: state.timekeeping.summary
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getClientWorkers,
            getUsers,
            sendInvite,
            getTimesheetSummary,
            getClientsProjects
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ClientDashboard);



// WEBPACK FOOTER //
// ./src/pages/dashboard/tenants/client/index.jsx